const webVitals = require('web-vitals');
/**
 * @function
 * @description initialize sending to Google Analytics
 * @param {Object} metric object with metric data
 */
function sendToGoogleAnalytics(metric) {
    window.dataLayer.push({
        event: 'web-vitals',
        event_action: metric.name,
        value: metric.delta,
        metric_id: metric.id
    });
}
/**
 * @function
 * @description initialize sending to Google Analytics
 */
function initSendToGTag() {
    webVitals.onCLS(sendToGoogleAnalytics);
    webVitals.onFID(sendToGoogleAnalytics);
    webVitals.onLCP(sendToGoogleAnalytics);
    webVitals.onINP(sendToGoogleAnalytics);
    webVitals.onFCP(sendToGoogleAnalytics);
    webVitals.onTTFB(sendToGoogleAnalytics);
}
module.exports = {
    init: initSendToGTag
};
